import React, { useEffect } from 'react';
import { useState } from 'react';
import { useAuth } from '../../commons/Auth';
import { useTranslation } from 'react-i18next';
import { useAlert } from 'react-alert';
import { useLoading } from '../../commons/Loading';
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from 'use-query-params';
import AlboPresentational from './AlboPresentational';
import axios from 'axios';

const { REACT_APP_DEFAULT_PAGINATION_LIMIT = 50 } = process.env;

const Albo = ({ profile }) => {
  const [{ newToken } = {}] = useAuth();
  const [data, setData] = useState([]);
  const [formattedCSVData, setFormattedCSVData] = useState([]);
  const [total, setTotal] = useState(0);
  const [t] = useTranslation('CONTACTS');
  const alert = useAlert();
  const { showLoading, hideLoading } = useLoading();

  const [query, setQuery] = useQueryParams({
    type: withDefault(StringParam),
    profileStatus: withDefault(StringParam),
    search: withDefault(StringParam),
    offset: NumberParam,
    limit: withDefault(NumberParam, +REACT_APP_DEFAULT_PAGINATION_LIMIT),
    region: withDefault(StringParam),
    district: withDefault(StringParam),
  });

  const {
    search,
    offset,
    limit,
    type,
    profileStatus,
    region,
    district,
  } = query;

  useEffect(() => {
    const fetchProfiles = async () => {
      showLoading();

      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/albo`,
        {
          headers: { Authorization: newToken },
          params: {
            search,
            offset,
            limit,
            type,
            profileStatus,
            region,
            district,
          },
        }
      );

      hideLoading();

      if (response instanceof Error) {
        return alert.error(t('COMMON:GENERIC_ERROR'));
      }

      const { data = [], headers = {} } = response;

      setData(data);
      setTotal(Number(headers['x-total-count']));
      hideLoading();
    };

    const fetchProfilesForExport = async () => {
      showLoading();

      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/albo/export`,
        {
          headers: { Authorization: newToken },
          params: {
            search,
            offset: 0,
            limit: 5000,
            type,
            profileStatus,
            region,
            district,
          },
        }
      );

      hideLoading();

      if (response instanceof Error) {
        return alert.error(t('COMMON:GENERIC_ERROR'));
      }

      const { data, headers = {} } = response;      

      setFormattedCSVData(data.formattedCSVData || []);
      hideLoading();
    };

    fetchProfiles();
    fetchProfilesForExport();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, offset, limit, type, profileStatus, region, district]);

  function onFilter(query) {
    if (
      (query.search && query.search !== search) ||
      (search && query.search === '') ||
      (query.type && query.type !== type) ||
      (type && query.type === '') ||
      (query.profileStatus && query.profileStatus !== profileStatus) ||
      (profileStatus && query.profileStatus === '') ||
      (query.region && query.region !== region) ||
      (region && query.region === '') ||
      (query.district && query.district !== district) ||
      (district && query.district === '') ||
      (query.limit && query.limit !== limit)
    ) {
      query.offset = 0; // return to first page
    }
    setQuery(query);
  }

  return (
    <AlboPresentational
      data={data}
      formattedData={formattedCSVData}
      total={total}
      query={query}
      onFilter={onFilter}
    />
  );
};

export default Albo;
